module.exports = __webpack_public_path__ + "static/media/floral-design-of-one-flower-on-a-branch-with-two-seeds-and-one-leaf-svgrepo-com.bba106b4.svg";